<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <v-snackbar v-model="showSnackBar" color="#3ea56e" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-dialog v-model="deleteDialogue" width="400">
      <v-card>
        <v-layout pa-4 wrap justify-center>
          <v-flex xs12>
            <span
              style="
                color: #000000;
                font-family: opensanssemibold;
                font-size: 18px;
              "
              >Do you want to delete this product ?</span
            >
          </v-flex>
          <v-flex xs12>
            <span
              style="
                color: #000000;
                font-family: opensanssemibold;
                font-size: 14px;
              "
              >{{ storage.productname }}</span
            >
          </v-flex>
          <v-flex xs6 px-2>
            <v-btn
              tile
              block
              depressed
              dark
              color="#ff1313"
              @click="deleteProduct"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                Yes
              </span>
            </v-btn>
          </v-flex>
          <v-flex xs6 px-2>
            <v-btn
              tile
              block
              depressed
              dark
              color="#1BD93B"
              @click="deleteDialogue = false"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                No
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-layout wrap align-center py-2>
      <!-- Item -->
      <v-flex xs12 md3>
        <v-layout wrap align-center>
          <v-flex xs4>
            <div style="background-color: #fafafa; border-radius: 12px; padding: 4px;">
              <v-img
                v-if="storage.photos && storage.photos.length > 0"
                :src="baseURL + 'u/' + storage.photos[0]"
                aspect-ratio="1"
                contain
                height="80px"
              ></v-img>
              <v-img
                v-else
                src="./../../../assets/noimg.png"
                aspect-ratio="1"
                contain
                height="80px"
              ></v-img>
            </div>
          </v-flex>
          <v-flex xs8 pl-3 text-left>
            <router-link :to="'/Seller/Product/' + storage._id" style="text-decoration: none;">
              <span style="font-family: opensansbold; font-size: 16px; color: #1c1c1c; display: block; line-height: 1.2; margin-bottom: 8px;">
                {{ storage.productname }}
              </span>
            </router-link>
            <!-- <v-chip x-small color="#eefaf3" text-color="#3ea56e" style="font-family: poppinsmedium; font-size: 11px; padding: 0 8px;">
              {{ storage.category ? storage.category.name : 'Category' }}
            </v-chip> -->
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- Stock Details -->
      <v-flex xs12 md2 text-left pl-md-4>
        <div>
          <span style="color: #8d8d8d; font-family: opensanslight; font-size: 12px; display: block;">Total Stock</span>
          <span style="font-family: opensansbold; font-size: 18px; color: #000; display: block;">{{ storage.quantity }}</span>
        </div>
        <div class="mt-3">
          <span style="color: #8d8d8d; font-family: opensanslight; font-size: 12px; display: block;">Available Stock</span>
          <span style="font-family: opensansbold; font-size: 14px; color: #3ea56e; display: block;">{{ storage.quantity }}</span>
        </div>
      </v-flex>

      <!-- Pricing -->
      <v-flex xs12 md2 text-left>
        <div>
          <span style="color: #8d8d8d; font-family: opensanslight; font-size: 12px; display: block;">Price</span>
          <span style="font-family: opensansbold; font-size: 18px; color: #000; display: block;">{{ storage.price }}</span>
        </div>
        <div class="mt-3">
          <span style="color: #8d8d8d; font-family: opensanslight; font-size: 12px; display: block;">Offer Price</span>
          <span style="font-family: opensansbold; font-size: 14px; color: #3ea56e; display: block;">{{ storage.offerPrice }}</span>
        </div>
      </v-flex>

      <!-- Offer -->
      <v-flex xs6 md1 text-left>
        <span style="color: #8d8d8d; font-family: opensanslight; font-size: 12px; display: block;">Offer</span>
        <span style="font-family: opensansbold; font-size: 18px; color: #000;">{{ storage.offer }}</span>
      </v-flex>

      <!-- Added On -->
      <v-flex xs6 md2 text-left>
        <div style="display: flex; align-items: center; margin-bottom: 12px;">
          <v-icon size="16" color="#8d8d8d" class="mr-2">mdi-calendar-blank-outline</v-icon>
          <span style="font-family: opensanssemibold; font-size: 13px; color: #1c1c1c;">
            {{ formatDate(storage.create_date).slice(0, 11) }}
          </span>
        </div>
        <div style="display: flex; align-items: center;">
          <v-icon size="16" color="#8d8d8d" class="mr-2">mdi-clock-outline</v-icon>
          <span style="font-family: opensanssemibold; font-size: 13px; color: #1c1c1c;">
            {{ formatDate(storage.create_date).slice(11, 20) }}
          </span>
        </div>
      </v-flex>

      <!-- Status -->
      <v-flex xs6 md1 text-left>
        <v-layout align-center>
          <v-switch
            :disabled="storage.status == 'Pending' || storage.status == 'Updated' || storage.status == 'Rejected'"
            v-model="storage.status"
            true-value="Active"
            false-value="Inactive"
            color="#3ea56e"
            hide-details
            :ripple="false"
            class="statusKey mt-0 pt-0"
            :loading="statusLoading"
            @click="changeProductStatus(storage)"
          ></v-switch>
          <span style="font-family: opensanssemibold; font-size: 13px; color: #1c1c1c; margin-left: 8px;">
            {{ storage.status }}
          </span>
          <v-tooltip bottom v-if="storage.status == 'Pending' || storage.status == 'Updated' || storage.status == 'Rejected'">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="#ff5722" size="18" class="ml-1" v-bind="attrs" v-on="on" style="cursor: pointer;">mdi-information</v-icon>
            </template>
            <span style="font-family: opensanssemibold; font-size: 13px;" v-if="storage.status == 'Rejected'">{{ storage.reason }}</span>
            <span style="font-family: opensanssemibold; font-size: 13px;" v-else>Awaiting admin approval</span>
          </v-tooltip>
        </v-layout>
      </v-flex>

      <!-- Actions -->
      <v-flex xs6 md1 text-center>
        <v-menu offset-y left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon outlined small color="#eaeaea" v-bind="attrs" v-on="on">
              <v-icon color="#555">mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item :to="'Product/Edit/' + storage._id">
              <v-list-item-title style="font-family: poppinsmedium; font-size: 13px;">Edit</v-list-item-title>
            </v-list-item>
            <v-list-item @click="deleteDialogue = true">
              <v-list-item-title style="color: #ff1313; font-family: poppinsmedium; font-size: 13px;">Delete</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["storage"],
  data() {
    return {
      appLoading: false,
      timeout: 5000,
      msg: "",
      ServerError: false,
      showSnackBar: false,
      statusLoading: false,
      deleteDialogue: false,
    };
  },
  computed: {
    isLowStock() {
      if (this.storage.minimumOrderQuantity) {
        return this.storage.quantity <= this.storage.minimumOrderQuantity * 5;
      } else {
        return this.storage.quantity < 10;
      }
    },
  },
  methods: {
    changeProductStatus(item) {
      this.statusLoading = true;
      axios({
        method: "POST",
        url: "/product/status",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: item._id,
          status: item.status,
        },
      })
        .then((response) => {
          this.statusLoading = false;
          if (response.data.status) {
            this.msg = "Product Status Changed to " + item.status;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.statusLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    deleteProduct() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/product/delete",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.storage._id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Product Deleted Successfully";
            this.showSnackBar = true;
            this.deleteDialogue = false;
            this.$emit("stepper", {
              getData: true,
            });
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      day = day < 10 ? "0" + day : day;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>

<style>
div.vertical-line {
  width: 1px; /* Line width */
  background-color: #8d8d8d; /* Line color */
  height: 100%; /* Override in-line if you want specific height. */
  float: left; /* Causes the line to float to left of content. 
        You can instead use position:absolute or display:inline-block
        if this fits better with your design */
}
.statusKey.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}
.hov:hover {
  background-color: red;
}
</style>
